/**
 * Normalize a timestamp that may arrive as Unix seconds, milliseconds, or an
 * ISO string into epoch milliseconds. `> 1e12` heuristic treats large numbers
 * as already-ms; smaller numbers are seconds. Invalid / empty input returns
 * `fallback` — callers that sort newest-first pass `Date.now()` so unknown
 * timestamps float to the top; catalogue views pass `0` to sink them.
 */
export function toMs(
  v: string | number | null | undefined,
  fallback = 0,
): number {
  if (!v) return fallback;
  if (typeof v === "number") return v > 1e12 ? v : v * 1000;
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? fallback : d.getTime();
}
